var _path, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKarma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7496 3C14.7496 3 19.7501 8.04886 19.7501 12.7708C19.7501 15.844 17.6351 18.0147 16.1558 19.1605V26.6617H13.3434V19.1605C11.8654 18.0147 9.75048 15.844 9.75048 12.7708C9.75048 8.04886 14.7496 3 14.7496 3ZM9.10109 9.20439C5.80351 8.00915 2.25 7.94733 2.25 7.94733C2.25 7.94733 2.36812 14.9704 5.78523 18.3102C7.61893 20.1031 10.0264 20.463 11.8671 20.4177C10.1572 18.824 8.32204 16.3648 8.32204 13.1198C8.32204 11.8106 8.63141 10.4834 9.10109 9.20439ZM20.3989 9.20439C20.8686 10.4834 21.178 11.8106 21.178 13.1198C21.178 16.3648 19.3428 18.824 17.6329 20.4177C19.4736 20.463 21.8797 20.1031 23.7148 18.3102C27.1319 14.9704 27.25 7.94733 27.25 7.94733C27.25 7.94733 23.6965 8.00915 20.3989 9.20439Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "karmamask",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 26,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7496 3C14.7496 3 19.7501 8.04886 19.7501 12.7708C19.7501 15.844 17.6351 18.0147 16.1558 19.1605V26.6617H13.3434V19.1605C11.8654 18.0147 9.75048 15.844 9.75048 12.7708C9.75048 8.04886 14.7496 3 14.7496 3ZM9.10109 9.20439C5.80351 8.00915 2.25 7.94733 2.25 7.94733C2.25 7.94733 2.36812 14.9704 5.78523 18.3102C7.61893 20.1031 10.0264 20.463 11.8671 20.4177C10.1572 18.824 8.32204 16.3648 8.32204 13.1198C8.32204 11.8106 8.63141 10.4834 9.10109 9.20439ZM20.3989 9.20439C20.8686 10.4834 21.178 11.8106 21.178 13.1198C21.178 16.3648 19.3428 18.824 17.6329 20.4177C19.4736 20.463 21.8797 20.1031 23.7148 18.3102C27.1319 14.9704 27.25 7.94733 27.25 7.94733C27.25 7.94733 23.6965 8.00915 20.3989 9.20439Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#karmamask)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    fill: "#FF7D5C",
    stroke: "#FF7D5C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKarma);
export default __webpack_public_path__ + "static/media/karma.61661a358ee69cf8541ac9b3efd05d95.svg";
export { ForwardRef as ReactComponent };